import { ChildBillBaseComponent } from 'types';
import { PriceDisplay } from 'components/molecules';
import { AccountActiveMarkIcon, AccountInactiveMarkIcon } from 'assets';
import { AppTableProps } from '../../../organisms';
import { commonTexts, settlementTexts } from '../../../../consts/text';
import { settlementChildrenBillComponentDTOFields } from '../../../../consts/settlementChildren/settlementChildrenDTOFields';

export const columnsPostpaid: AppTableProps<ChildBillBaseComponent>['columns'] = [
    {
        title: settlementTexts.children.billParts.type,
        dataIndex: settlementChildrenBillComponentDTOFields.name,
        key: settlementChildrenBillComponentDTOFields.name,
        isVisibleAsExtendableInMobile: false,
        width: '15%',
    },
    {
        title: commonTexts.dataLabels.grossAmount,
        dataIndex: settlementChildrenBillComponentDTOFields.grossAmount,
        key: settlementChildrenBillComponentDTOFields.grossAmount,
        isVisibleAsExtendableInMobile: true,
        render: (grossAmount: ChildBillBaseComponent['grossAmount']) => (
            <PriceDisplay value={grossAmount} showEmptyValue={false} />
        ),
        width: '20%',
    },
    {
        title: commonTexts.dataLabels.netAmount,
        dataIndex: settlementChildrenBillComponentDTOFields.netAmount,
        key: settlementChildrenBillComponentDTOFields.netAmount,
        isVisibleAsExtendableInMobile: true,
        render: (netAmount: ChildBillBaseComponent['netAmount']) => (
            <PriceDisplay value={netAmount} showEmptyValue={false} />
        ),
        width: '20%',
    },
    {
        title: commonTexts.dataLabels.vatAmount,
        dataIndex: settlementChildrenBillComponentDTOFields.vatAmount,
        key: settlementChildrenBillComponentDTOFields.vatAmount,
        isVisibleAsExtendableInMobile: true,
        render: (vatAmount: ChildBillBaseComponent['vatAmount']) => (
            <PriceDisplay value={vatAmount} showEmptyValue={false} />
        ),
        width: '15%',
    },
    {
        title: settlementTexts.children.billParts.discount,
        dataIndex: settlementChildrenBillComponentDTOFields.discountString,
        key: settlementChildrenBillComponentDTOFields.discountString,
        isInvisibleInMobile: true,
        width: '10%',
    },
    {
        title: settlementTexts.children.billParts.onInvoice,
        dataIndex: settlementChildrenBillComponentDTOFields.onInvoice,
        key: settlementChildrenBillComponentDTOFields.onInvoice,
        render: (onInvoice: ChildBillBaseComponent['onInvoice']) =>
            onInvoice ? <AccountActiveMarkIcon /> : <AccountInactiveMarkIcon />,
        align: 'center',
        isInvisibleInMobile: false,
        width: '10%',
    },
];
